module.exports = "/_next/static/images/laptop-e2d76e395fde71b86afc5d9ca14c7898.png";